/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import './InlineSelectInput.css';

import DropdownArrow from './DropdownArrow';

class InlineSelectInput extends React.Component {

  render() {
    return (
      <div className="cmp-inlineselectinput" style={this.props.style}>
        {
          this.props.showArrow ? (
            <div className="cmp-inlineselectinput-icon">
              <DropdownArrow />
            </div>
          ) : null
        }

        <select
          name={this.props.htmlId}
          className={this.props.className}
          id={this.props.htmlId}
          value={this.props.value}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
          onChange={(e) => { this.props.onChange(e.target.value); }}
        >
          {this.props.options}
        </select>
      </div>
    );
  }
}
InlineSelectInput.propTypes = {
  htmlId: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  showArrow: PropTypes.bool,
};

export default InlineSelectInput;
